module.exports = __webpack_public_path__ + "img/Gabon.e52cb2ed.svg";